import { Button } from 'wss3-forge'
import { ArrowEnter20Regular } from '@fluentui/react-icons'
import { webba } from '../lib/webba.js'

const RETURN_URL_KEY = 'webba_return_url'

export function LoginButton() {
  const handleClick = async () => {
    const here = window.location.pathname + window.location.search
    if (!here.startsWith('/auth/') && here !== '/login') {
      sessionStorage.setItem(RETURN_URL_KEY, here)
    }
    await webba.login()
  }

  return (
    <Button variant="primary" size="lg" icon={<ArrowEnter20Regular />} onClick={handleClick}>
      Connexion via Webba
    </Button>
  )
}
